import React, { Dispatch, useEffect, useState } from 'react';
import { ContFilter, Container } from './styles';
import { Button, Modal } from 'antd';
import { CloseOutlined, FilterOutlined } from '@ant-design/icons';
import type { ColumnType } from 'antd/lib/table';
import TitlePage from '../../../../components/TitlePage';
import Filter from './components/Filter';
import TableSort from '../../../../components/TableSort';
import ModalItensNota from './components/Modal';
import CardMobile from './components/CardMobile';
import TextTable from '../../../../components/TextTable';
import ModalEditarColeta from './components/Modal/ModalEditarColeta';
import ModalCriarOrdemDeColeta from '../../components/ModalCriarOrdemDeCarga';
import Refresh from '../../../../components/Refresh';
import { ExportBtn } from '../../../../components/_REFACTORED/ExportBtn';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../store';
import { loadRequest, sorterColetaCD } from '../../../../store/ducks/coletaNoCd/actions';
import mask, { maskCurrency } from '../../../../utils/mask';
import { HandleClickRowActive } from '../../../../utils/handleclickrowactive';
import { Sorter, sorterParamsHandle } from '../../../../utils/sorte';
import { useWindowSize } from '../../../../hook/useWindowSize';
import { IColetaNoCd } from '../../../../store/ducks/coletaNoCd/types';
import TitleTable from '../../../../components/TitleTable';
import { exportDataColetaNoCd } from './hooks';
import { ColetaNoCdServices } from './services/coletaNoCdServices';
import { TIPO_WMS } from 'utils/enums/tipoWms';

export interface ItensColeta {
  key: React.Key;
  nuNotaPedido: number;
  cliente: string;
  pesoBruto: number;
  valor: number;
}

const ColetaNoCd: React.FC = () => {
  const { width }: any = useWindowSize();
  const loading = useSelector((state: ApplicationState) => state.ColetaNoCd.loading);
  const coletas = useSelector((state: ApplicationState) => state.ColetaNoCd.data);
  const pagination = useSelector((state: ApplicationState) => state.ColetaNoCd.pagination);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const filter = useSelector((state: ApplicationState) => state.ColetaNoCd.filter);
  const dispatch = useDispatch<Dispatch<Action>>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalEditVisible, setIsModalEditVisible] = useState(false);
  const [addWeight, setAddweight] = useState(0);
  const [amount, setAmount] = useState(0);
  const [arraySelectedItens, setaArraySelectedItens] = useState<ItensColeta[]>();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [filterActive, setFilterActive] = useState<string[]>([]);

  const getData = async () => {
    const { data } = await ColetaNoCdServices.getAllData(
      cddAtivo?.codCdd,
      filter,
      inscricaoAtiva,
      pagination.total
    );

    return exportDataColetaNoCd(data.coletas);
  };

  const columns: ColumnType<IColetaNoCd>[] = [
    {
      title: <TitleTable>Pedido</TitleTable>,
      dataIndex: 'nuNotaPedido',
      key: 'nuNotaPedido',
      align: 'left',
      width: 120,
      render: (text) => {
        return text ? <TextTable>{text}</TextTable> : <TextTable>Não informado</TextTable>;
      },
    },
    {
      title: <TitleTable>Nota fiscal</TitleTable>,
      dataIndex: 'numNF',
      key: 'numNF',
      align: 'center',
      width: 150,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 2,
      },
      render: (text, record) => {
        return text ? (
          <>{<ModalItensNota numNF={text} nuNota={record?.nunotaNF} />}</>
        ) : (
          <TextTable>Não informada</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Parceiro</TitleTable>,
      dataIndex: 'cliente',
      key: 'cliente',
      align: 'center',
      width: 300,
      sorter: {
        compare: Sorter.STRING,
        multiple: 3,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },

    {
      title: <TitleTable>Emissão do pedido</TitleTable>,
      dataIndex: 'dtEmissao',
      key: 'dtEmissao',
      align: 'center',
      width: 200,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 1,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('date', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },

    {
      title: <TitleTable>Transportadora</TitleTable>,
      dataIndex: 'transportadora',
      key: 'transportadora',
      align: 'center',
      width: 300,
      sorter: {
        compare: Sorter.STRING,
        multiple: 4,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('transportadoraUf', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Cidade/UF destino</TitleTable>,
      dataIndex: 'cidadeUf',
      key: 'cidadeUf',
      align: 'center',
      width: 220,
      sorter: {
        compare: Sorter.STRING,
        multiple: 5,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('cidadeUf', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Peso bruto</TitleTable>,
      dataIndex: 'pesoBruto',
      key: 'pesoBruto',
      align: 'center',
      width: 150,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 6,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('peso', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      title: <TitleTable>Valor</TitleTable>,
      dataIndex: 'valor',
      key: 'valor',
      align: 'center',
      width: 180,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 7,
      },
      render: (text) => {
        return text ? (
          <TextTable>{mask('currency', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
  ];

  useEffect(() => {
    setFilterActive(Object.keys(filter ?? {}));
  }, [filter]);

  useEffect(() => {
    setSelectedRowKeys([]);
    setaArraySelectedItens([]);
    setAmount(0);
    setAddweight(0);
  }, [dispatch, filter, inscricaoAtiva, cddAtivo]);

  const rowSelection = {
    selectedRowKeys: selectedRowKeys,

    onChange: (selectedRowKeys: React.Key[], selectedRows: ItensColeta[]) => {
      setSelectedRowKeys(selectedRowKeys);
      const resArr: any = [];
      const resArrAmount: any = [];

      selectedRows.map((itemMovi) => resArr.push(+itemMovi.pesoBruto));
      setAddweight(resArr.reduce((a: any, b: any) => a + b, 0).toFixed(2));
      selectedRows.map((itemMovi) => resArrAmount.push(+itemMovi.valor));
      setAmount(resArrAmount.reduce((a: any, b: any) => a + b, 0).toFixed(2));
      setaArraySelectedItens(selectedRows);
    },

    getCheckboxProps: (record: ItensColeta) => ({
      cliente: record.cliente,
      nuNotaPedido: record.nuNotaPedido,
    }),
  };

  return (
    <>
      <Refresh
        loadRequest={() =>
          dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd as number, pagination))
        }
      />
      <Filter />

      <Container>
        <div className="menuItens">
          <TitlePage>
            <div>
              <span>Coleta no CD</span>
              <ul className="totalPesoValor">
                <li>
                  <TextTable>Peso total:</TextTable> <TextTable>{addWeight} KG</TextTable>
                </li>
                <li>
                  <TextTable>Valor total:</TextTable> <TextTable>{maskCurrency(amount)}</TextTable>
                </li>
              </ul>
            </div>
          </TitlePage>

          <ContFilter>
            {filterActive.map((item) => (
              <p key={item}>
                {item === 'nuNota' && (
                  <>
                    <FilterOutlined /> Pedido
                  </>
                )}
                {item === 'nuNotaEmitida' && (
                  <>
                    <FilterOutlined />
                    Nota fiscal
                  </>
                )}
                {item === 'codParceiro' && (
                  <>
                    <FilterOutlined />
                    Parceiro
                  </>
                )}
                {item === 'codTransportadora' && (
                  <>
                    <FilterOutlined />
                    Transportadora
                  </>
                )}
                {item === 'dhAgendamento' && (
                  <>
                    <FilterOutlined />
                    Data
                  </>
                )}
                {item === 'codEstado' && (
                  <>
                    <FilterOutlined />
                    Estado
                  </>
                )}
                {item === 'codCidade' && (
                  <>
                    <FilterOutlined />
                    Cidade
                  </>
                )}
              </p>
            ))}
          </ContFilter>

          <div className="esqItens">
            <ModalCriarOrdemDeColeta
              tipoWms={TIPO_WMS.coleta}
              itensSelected={arraySelectedItens}
              setaArraySelectedItens={setaArraySelectedItens}
              atualizaTabelaColeta={() =>
                dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd as number))
              }
            />
            <ExportBtn
              onGetAllData={getData}
              screenData={exportDataColetaNoCd(coletas)}
              filename={'coletas-no-cd'}
            />
          </div>
        </div>

        <Modal
          centered
          title="Editar Ordem de carga"
          visible={isModalEditVisible}
          onCancel={() => setIsModalVisible(false)}
          maskClosable={false}
          closable={true}
          destroyOnClose={true}
          closeIcon={<CloseOutlined />}
          keyboard={true}
          width={750}
          footer={[
            <Button key="back" size="middle" onClick={() => setIsModalEditVisible(false)}>
              Cancelar
            </Button>,
            <Button type="primary">Salvar</Button>,
          ]}
        >
          <ModalEditarColeta />
        </Modal>

        {width > 768 && (
          <TableSort
            rowSelection={{
              type: 'checkbox',
              ...rowSelection,
            }}
            dataSource={coletas}
            style={{ fontSize: 10, display: 'inline' }}
            columns={columns}
            scroll={{ x: 1400 }}
            size={'large'}
            onChange={(pagination: any, _: any, sorter: any) => {
              dispatch(
                loadRequest(
                  filter,
                  filter?.codParceiro ? [+filter.codParceiro] : inscricaoAtiva,
                  cddAtivo?.codCdd as number,
                  pagination,
                  sorterParamsHandle(sorter)
                )
              );
              dispatch(sorterColetaCD(sorterParamsHandle(sorter)));
            }}
            pagination={pagination}
            className="table"
            loading={loading}
            onRow={(record: any, rowIndex: any) => {
              return {
                onClick: (event: React.MouseEvent<HTMLElement>) =>
                  HandleClickRowActive(event, record),
              };
            }}
            rowKey={'nuNotaPedido'}
          />
        )}
        {width <= 768 && (
          <CardMobile
            props={coletas}
            pagination={pagination}
            loading={loading}
            inscricaoAtiva={inscricaoAtiva}
            cddAtivo={cddAtivo}
            filter={filter}
            setAddweight={setAddweight}
            setAmount={setAmount}
            setaArraySelectedItens={setaArraySelectedItens}
          />
        )}
      </Container>
    </>
  );
};

export default ColetaNoCd;
